module.exports = __webpack_public_path__ + "media/white_belt_A.fafa8a84.mp3";